import styles from "./InfoPage.module.scss";
import Nav from "@/components/Header/Nav/Nav";
import Footer from "@/components/Footer/Footer";
import CookiePopupButton from "@/components/CookieBanner/CookiePopupButton.tsx";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { getSiteConfig } from "@/config/siteConfigs";

const PaymentSuccess = () => {
  const { t } = useTranslation("pages");
  const siteConfig = getSiteConfig();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <title>{t("paymentSuccess.meta.title")}</title>
      <link rel="icon" href="/images/favicon.ico" type="image/x-icon" />
      <Nav />
      <h2 className={`sectionContainer ${styles.title}`}>
        {t("paymentSuccess.title")}
      </h2>
      <div className="container sectionContainer sectionContainerWhite">
        <p className={styles.infoPageText}>
          {t("paymentSuccess.message")}
          <br />
          {t("paymentSuccess.description")}
        </p>

        <p className={styles.infoPageText}>
          {t("paymentSuccess.contactSupport")}
          <br />
          Telefon: {siteConfig.contact.phone}
          <br />
          E-Mail: {siteConfig.contact.email}
        </p>
      </div>
      <CookiePopupButton />
      <Footer />
    </div>
  );
};

export default PaymentSuccess;
